import _ from "lodash";
import { PopupCenter } from "./popup";

var popupSize = {
  4: [1024, 665],
  5: [1024, 620],
  6: [1024, 805],
  7: [1024, 665],
  8: [1080, 665],
  9: [1024, 665],
  11: [1000, 665],
  12: [1024, 665],
  13: [1024, 665],
  15: [1000, 665],
  16: [1000, 665],
  17: [1000, 665],
  18: [1000, 604],
  19: [1000, 665],
  20: [1000, 790],
  21: [1000, 790],
  22: [1000, 790],
  23: [1000, 605],
  24: [1000, 790],
  25: [1000, 790],
  26: [1000, 790],
  27: [1024, 665],
  28: [1000, 790],
  29: [1000, 790],
  30: [1000, 720],
  31: [1000, 720],
  32: [1000, 790],
  33: [1000, 790],
  35: [1024, 665],
  36: [1024, 665],
  37: [1000, 600],
  38: [1000, 790],
  39: [1000, 720],
  40: [1000, 720],
  41: [1000, 790],
  42: [1000, 790],
  43: [1000, 600],
  44: [1000, 790],
  45: [1000, 605],
  46: [1050, 630],
  47: [1000, 790],
  48: [1000, 790],
  49: [1000, 790],
  50: [1000, 790],
  51: [1050, 630],
  52: [1000, 620],
  66: [1000, 605],
  72: [1000, 584]
};

const filterSlots = ({ labels, slots, searchQuery, labelId }) => {
  if (searchQuery) {
    const filtered = _.map(
      _.filter(slots, (slot) =>
        slot.name_en?.replace(/\s/g, "").toLowerCase().includes(searchQuery)
      ),
      (i) => i.id
    );

    let result = {};
    _.forEach(labels, (l) => {
      if (GROUPED_CATEGORY_IDS.includes(l.id)) return;
      const match = _.intersection(
        _.map(l.slots, (s) => parseInt(s)),
        filtered
      );
      if (match.length > 0) {
        result[
          JSON.stringify({
            id: l.id,
            operator_name: l.name,
          })
        ] = _.map(match, (v) => slots[v]);
      }
    });
    return result;

    /*return _.groupBy(filtered, (v) => {
      return JSON.stringify({
        id: v.operator_id,
        operator_name: v.operator_name,
      });
    });*/
  }
  const provider = labelId
    ? _.find(labels, (v) => parseInt(v.id) === parseInt(labelId))
    : labels[0];

  if (provider) {
    //new & top
    if ([59, 60].includes(provider.id)) {
      /*return _.groupBy(providerSlots, (i) =>
        JSON.stringify({
          id: i.label_ids[0],
          operator_name: _.find(
            labels,
            (v) => parseInt(v.id) === parseInt(i.label_ids[0])
          ).name,
        })
      );*/
      let result = {};
      _.forEach(labels, (l) => {
        if (GROUPED_CATEGORY_IDS.includes(l.id)) return;
        const match = _.intersection(l.slots, provider.slots);
        if (match.length > 0) {
          result[
            JSON.stringify({
              id: l.id,
              operator_name: l.name,
            })
          ] = _.map(match, (v) => slots[v]);
        }
      });
      return result;
    }
    return {
      [JSON.stringify({
        id: provider.id,
        operator_name: provider.name,
      })]: _.map(provider.slots, (v) => slots[v]),
    };
  }
  return [];
};

const filterCategories = ({ labels, slots, searchQuery }) => {
  let filteredLabels = labels;
  if (searchQuery) {
    filteredLabels = _.filter(labels, (label) => {
      const labelMatch = label.name
        ?.replace(/\s/g, "")
        .toLowerCase()
        .includes(searchQuery);

      return labelMatch
        ? labelMatch
        : _.some(label.slots, (slotId) =>
            slots[slotId].name_en
              ?.replace(/\s/g, "")
              .toLowerCase()
              .includes(searchQuery)
          );
    });
  }

  return _.map(filteredLabels, (label) => ({
    id: label.id,
    name: label.name,
    slotCount: label.slots?.length,
  }));
};

const open = ({ slot, lang, platform, inline = false, navigate , mod}) => {
  let url = `/${lang}/playSlot?catid=${slot.catid}&operator=${slot.operator_id}&game=${slot.gameid}&name=${slot.name_en}&provider=${slot.provider}`;
  const title = "Lider-Bet.com";

  if(mod === 'test'){
    url = url.concat('&mod=test')
  }


  if (window.navigator.platform.toLowerCase().indexOf("macintel") > -1) {
    platform = "mob";
  }
  //platform = window.navigator.platform.toLowerCase().indexOf("macintel")>-1?'mob':'web';
  /* const userAgent = navigator.userAgent.toLowerCase();
   const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
 
   if (isTablet) {
        platform = "mob"
   }*/
  if (platform === "web" && !inline) {
    let sizes = popupSize[parseInt(slot.catid)];
    if (sizes === undefined) {
      sizes = [1000, 790];
    }

    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

    const left = width / 2 - sizes[0] / 2 + dualScreenLeft;
    const top = height / 2 - sizes[1] / 2 + dualScreenTop;

    /*const newWindow = window.open(
      url,
      title,
      "directories=no,titlebar=no,toolbar=no,location=no,menubar=no, resizable=false, scrollbars=no, status=no, width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        top +
        ", left=" +
        left
    );
*/
    PopupCenter({
      url: url,
      title: title,
      navigate: navigate,
      w: sizes[0],
      h: sizes[1],
      top: top,
      left: left,
    });
  } else if (platform === "mob") {
    navigate(url);
  } else {
    //inline
    window.location.replace(url);
  }
};

const NEW_CATEGORY_IDS = [101,102];
const GROUPED_CATEGORY_IDS = [59, 60, 65, 92];

export default { filterSlots, filterCategories, open, NEW_CATEGORY_IDS, GROUPED_CATEGORY_IDS };
